@if (config.resources) {
  <div
    class="resources"
    [ngClass]="{
      'resources--horizontal': config.isHorizontal,
      'resources--vertical': !config.isHorizontal,
    }"
  >
    @for (resource of config.resources.resources; track resource) {
      <div class="resource">
        <icon class="resource__icon" [name]="resource.icon"> </icon>
        <p
          class="t-alt resource__description"
          [innerHTML]="resource.description"
        ></p>
        <footer class="resource__footer u-flex u-justifyEnd">
          <ng-template
            [ngTemplateOutlet]="link"
            [ngTemplateOutletContext]="{ resource: resource }"
          ></ng-template>
        </footer>
      </div>
    }
  </div>
}

@if (config.resources) {
  @for (resource of config.resources.resources; track resource) {
    <card class="resources__card">
      <div title class="resources__card-title">
        <icon [name]="resource.icon"></icon>
        <p
          class="resources__card-description"
          [innerHTML]="resource.description"
        ></p>
      </div>
      <div footer class="resources__card-footer u-flex u-justifyEnd">
        <div class="u-justifyEnd">
          <ng-template
            [ngTemplateOutlet]="link"
            [ngTemplateOutletContext]="{ resource: resource }"
          ></ng-template>
        </div>
      </div>
    </card>
  }
}

<ng-template #link let-resource="resource">
  <div class="resources__footer--link">
    <ds-link
      [linkConfig]="getLinkConfigs(resource)"
      [externalSiteModalConfig]="externalSiteModalConfig"
      (linkClicked)="handleLinkClicked(resource)"
    >
      <span class="resource__label">
        {{ resource.label }}
      </span>
    </ds-link>
  </div>
</ng-template>
